<template>
  <filtered-search
    :search-filters="searchFilters"
    :search-route="searchRoute"
    :placeHolder="placeHolder"
    :model="model"
  >
    <template
      slot="results"
      slot-scope="{ items }"
    >
      <li
        v-for="(manufacturer, index) in items"
        :key="manufacturer.id"
        :class="{
          'border-t border-gray-200': index > 0
        }"
      >
        <a
            :href="manufacturer.route"
            class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
        >
            <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="flex items-center flex-1 min-w-0">
                    <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-3 md:gap-4">
                        <div>
                            <div class="mb-1 font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 visited:text-indigo-800 text-md">
                                <span v-html="manufacturer.name">
                                    {{ manufacturer.name }}
                                </span>
                                <span
                                    v-if="manufacturer.name"
                                    class="ml-2 font-normal text-gray-600"
                                >
                                </span>
                            </div>
                            <div class="sm:flex">
                                <div
                                    v-if="manufacturer.location"
                                    class="flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
                                >
                                    <svg
                                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                    {{ manufacturer.location }}
                                </div>
                            </div>

                        </div>
                        <div class="hidden col-span-2 md:block">
                            <div>
                                <div
                                    v-if="manufacturer.specialties.length"
                                    class="flex items-center text-sm font-medium leading-5 text-gray-900 truncate"
                                >
                                    Specialties:
                                    <span
                                        v-for="(specialty, specialtyIndex) in manufacturer.specialties"
                                        :key="specialty.id"
                                        class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-gray-100 text-gray-800"
                                    >
                                        {{ specialty.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <svg
                        class="w-5 h-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>
            </div>
        </a>
      </li>
    </template>
  </filtered-search>
</template>

<script>
export default {
  props: {
    searchFilters: {
      type: [Array, Object],
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    placeHolder: {
        type: String,
        required: false,
        default: 'Search...'
    },
    model: {
        type: [Array, Object],
        required: true
    }
  },

  data: () => ({}),
};
</script>
